import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, styled, InputBase, alpha } from "@mui/material";
import './Search.scss'

export const RISearch = ({ setSearchData, searchList }) => {

    const Search = styled('div')(({ theme }) => ({
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: alpha(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '80%',

    }));

    const StyledInputBase = styled(InputBase)(({ theme }) => ({
        color: 'black',
        borderRadius: '20px',
        backgroundColor: ' #F0F3F6',
        '& .MuiInputBase-input': {
            // vertical padding + font size from searchIcon
            paddingLeft: `calc(1em + ${theme.spacing(1)})`,
            transition: theme.transitions.create('width'),
            width: '80%',

        },
    }));

    return (
        <Search>
            <StyledInputBase
                placeholder="Search here"
                inputProps={{ 'aria-label': 'search' }}
                endAdornment={
                    <InputAdornment position="end">
                        <SearchIcon style={{ marginRight: '0px', cursor: 'pointer', marginTop:'0px' }} />
                    </InputAdornment>
                }
            />
        </Search>
    )
}